import { connect } from 'react-redux';
import { bindActionCreators, Dispatch, Action } from 'redux';

import { StateType } from 'types';
import { getIncentiveAgreementById } from 'redux/actions/technicalLicense';
import {
  selectIncentiveAgreement,
  selectTechnicalLicenseId,
  selectIncentiveAgreementStatus,
} from 'redux/selectors/technicalLicenses';

const mapStateToProps = (state: StateType) => ({
  incentiveAgreement: selectIncentiveAgreement(state),
  technicalLicenseID: selectTechnicalLicenseId(state),
  incentiveAgreementStatus: selectIncentiveAgreementStatus(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({ getIncentiveAgreementById }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
